// Iter-282b — Single source of truth on the frontend for the ethnicity
// controlled vocabulary. Stays in lockstep with backend
// /api/profile-info/ethnicity-options. We hard-code the same list here
// so the dropdown renders without a network round-trip; we still fetch
// from the API once on mount as a "drift detector" — if the server adds
// new options, the dropdown picks them up.
export const ETHNICITY_OPTIONS = [
  'American Indian or Alaska Native',
  'Asian',
  'Black or African American',
  'Hispanic or Latino',
  'Middle Eastern or North African',
  'Native Hawaiian or Other Pacific Islander',
  'White',
  'Two or More Races',
  'Other',
  'Prefer Not to Answer',
];

export const ETHNICITY_PLACEHOLDER = 'Prefer Not to Answer';
